import { FC } from 'react';
import { useTranslation } from 'next-i18next';
import Typography from 'src/common/components/Typography';
import { NEW_TAB_ATTRIBUTES } from 'src/common/constants';
import Logo from 'src/common/components/Logo';
import styles from './FooterWhiteLabeled.module.scss';

export type FooterWhiteLabeledProps = {
  ownerEmail?: string;
};
const FooterWhiteLabeled: FC<FooterWhiteLabeledProps> = ({ ownerEmail }) => {
  const [t] = useTranslation('footer-white-labeled');

  return (
    <div className={styles.root}>
      {ownerEmail && (
        <>
          <Typography
            type="p"
            size="body-s"
            className={styles.title}
          >
            {t('footer-white-labeled--title')}
          </Typography>
          <a
            href={`mailto:${ownerEmail}`}
            className={styles.email}
            {...NEW_TAB_ATTRIBUTES}
          >
            {ownerEmail}
          </a>
        </>
      )}
      <Typography
        type="p"
        weight="semibold"
        size="body-s"
        className={styles.poweredBy}
      >
        {t('footer-white-labeled--powered-by')}
      </Typography>
      <div className={styles.logo}>
        <Logo width={100} height={17} variant="monotone" />
      </div>
      <Typography
        type="p"
        size="body-s"
        className={styles.slogan}
      >
        {t('footer-white-labeled--slogan')}
      </Typography>
    </div>
  );
};

export default FooterWhiteLabeled;
